var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-size-h3 text-default text-center"},[_c('span',[_vm._v(" "+_vm._s(_vm.paymentMessage)+" ")]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.formattedStartDay)+", "+_vm._s(_vm.formattedStartDate)+" at "+_vm._s(_vm.formattedStartTime)+". ")]),_c('span',[_vm._v(" "+_vm._s(_vm.statusMessage)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }